import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import PriorityHigh from '@material-ui/icons/PriorityHigh';
import MaterialTable from 'material-table';

import Moment from 'moment';
import { formatCurrency } from '../../../../utils/currencyFormatter';
import poAwbListStyles from './poAwbList.module.css';
import commonStyles from '../../../common/common.module.css';
import { AttachFile } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';
import PickupOrderAwb from '../../../../models/PickupOrderAwb';
import { Badge } from '@material-ui/core';
import DotIcon from '@material-ui/icons/Lens';
import addIcon from '../../../../assets/add.svg';
import editIcon from '../../../../assets/editIcon.svg';
import PickupOrderGha from '../../../../models/PickupOrderGha';
import User from '../../../../models/User';

const iconFontSize = 20;
const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    green: {
      color: 'green !important',
      fontSize: '14px',
      margin: 'auto'
    },
    red: {
      color: 'red !important',
      fontSize: '14px',
      margin: 'auto'
    },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)',
    },
    priorityHigh: {
      color: '#FF0000',
      fontSize: '15px'
    },
    radio: {
      padding: '0',
      '& svg': {
        fontSize: '20px'
      }
    },
    disabledBadgeIcon: {
      '&>span': {
        color: 'rgb(204, 204, 204)',
        borderColor: 'rgb(204, 204, 204)'
      }
    },
    manualEntryBtn: {
      width: '28px'
    },
    plus: {
      textAlign: 'right',
      paddingRight: '25px'
    },
    selected: {
      background: 'orange'
    },
    tableSection: {
      '& td': {
        color: 'inherit !important'
      }
    },
    ordersPaper: {
      '& .MuiPaper-root': {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      }
    }
  });


interface PoAwbListProps {
  classes: any;
  awbs: Array<PickupOrderAwb>;
  selectedAwbCode: string;
  selectedAwbNumber: string;
  addAwb: Function;
  handleChange: any;
  openDialog: (type: string, awbCode: string, awbNumber: string) => void;
  po: PickupOrderGha;
  changed: boolean;
  openCloseEditAwbs: Function;
  user: User;
};

const PADDING_RIGHT_CELLS = '12px';
const PADDING_LEFT_CELLS = '8px';
const cellStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };
const headerStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };

const poAwbList = (props: PoAwbListProps) => {
  console.log('🚀 ~ poAwbList ~ props:', props)
  const { classes } = props;

  const isManagerOrSupervisor = props.user.roleName === 'GHA Manager' || props.user.roleName === 'GHA Supervisor';

  return (

    <div className={`${commonStyles.wrapper} ${poAwbListStyles.wrapper}`} id='myTable'>
      <div className={`${commonStyles.fSpaceBtw} ${commonStyles.mb2}`}>
        <h3 className={`${commonStyles.header}`}> List of Airwaybills</h3>
        {props.awbs[0] && !props.po.delivered_date && <div className={poAwbListStyles.plus}>
          <div className={`${poAwbListStyles.plus}`}>
            {/* Add icon */}

            <img
              alt="Edit"
              src={editIcon}
              className={`${poAwbListStyles.manualEntryBtn} ${poAwbListStyles.editIcon}`}
              style={!isManagerOrSupervisor ? { opacity: 0.5, pointerEvents: 'none' } : {}}
              onClick={isManagerOrSupervisor ? () => props.openCloseEditAwbs('open') : undefined}
            />
            <img
              alt="Add"
              src={addIcon}
              className={poAwbListStyles.manualEntryBtn}
              onClick={() => props.addAwb()}
            />

            {/* Edit icon */}
          </div>
        </div>}
      </div>
      <div className={`${ classes.tableSection } ${ classes.ordersPaper } ${ commonStyles.paperTable } ${ commonStyles.SelectTable }`} >
      <MaterialTable

        data = { props.awbs }
        columns = {[
          { cellStyle: { paddingLeft: '3px', paddingRight: 0 }, headerStyle: { paddingLeft: '3px', paddingRight: 0 },
          render: (rowData: PickupOrderAwb) => {

            return <Radio
              checked={ props.selectedAwbCode === rowData.code &&  props.selectedAwbNumber === rowData.number }
              onChange={ (e: any) => props.handleChange(e, rowData.version) }
              value={ rowData.code + '-' + rowData.number }
              name="selectedAwbID"
              color="default"
              className= { classes.radio }
            />
          },
        },
          { title: 'Airwaybill', field: '', cellStyle, headerStyle,
            render: (rowData: PickupOrderAwb) => {

              return <span>{ rowData.code }-{ rowData.number } {rowData.returned? <span className={poAwbListStyles.returnToDriverText}>Returned to driver</span>: null}</span>;
            }
          },
          { title: 'Flight', field: '', cellStyle:{ minWidth: '100px' }, headerStyle,
            render: (rowData: PickupOrderAwb) => {

              const isValid: boolean = rowData.color_status === 'green';
              const Attention: JSX.Element | null = isValid ? null : <PriorityHigh className={ classes.priorityHigh }/>;
              const flightDate: string = rowData.parts && rowData.parts.length ? Moment(rowData.parts[0].flight_date).format('DDMMM').toUpperCase(): '';
              const flightNumber: string = rowData.parts.length > 1 ? 'PART SHIPMENT' : `${ rowData.parts[0].flight_no }/${ flightDate }`;

              return <span>
                  <span>{ flightNumber }</span>
                </span>;
            }
          },
          { title: 'Pcs', field: 'pieces', cellStyle: Object.assign(cellStyle, {paddingRight: '15px'}), headerStyle },
          { title: 'Wgt', field: 'weight', cellStyle, headerStyle,
            render: (rowData: PickupOrderAwb) => {

              const weight: number = +(rowData.weight);
              return <span>{ weight.toFixed(1) }K</span>;
            }
          },
          { title: 'Due', field: '', type: 'currency', cellStyle: { textAlign: 'left' }, headerStyle: { textAlign: 'left' },
            render: (rowData: PickupOrderAwb) => {
              const dueAmount = rowData.due ? Number(rowData.due) : 0;
              return formatCurrency(dueAmount, 2, '$');
            }
          },
          { title: 'Status', field: 'status', cellStyle, headerStyle },
          { title: 'Action', cellStyle, headerStyle,
            render: (rowData: PickupOrderAwb) => {

              const colorClass: any = rowData.color_status ? classes[rowData.color_status] : '';
              const rowAwbNbr: string = rowData.code + '-' + rowData.number;
              const selectedAwbNbr: string = props.selectedAwbCode + '-' + props.selectedAwbNumber;
              const styleClass: string = rowAwbNbr === selectedAwbNbr ? classes.materialIcon : classes.disabledIcon;
              const styleClassBadge: string = rowAwbNbr === selectedAwbNbr ? classes.materialIcon : classes.disabledBadgeIcon;

              return <span className={ poAwbListStyles.awbActionsList } >
                <Tooltip title="Attach file">
                  <span>
                    <Badge className={ `${commonStyles.attachmentBadge} ${styleClassBadge}` } color="secondary" badgeContent={ rowData.attachmentCount }>
                      <AttachFile className={ styleClass } onClick={(events) => props.openDialog('attachments', rowData.code, rowData.number) } />
                    </Badge>
                  </span>
                </Tooltip>
                <DotIcon className={ colorClass } />
                </span>;
            }
          }
        ]}

        options = {{
          paging: false,
          pageSize: 5,
          maxBodyHeight: '342px',
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          showTitle: false,
          pageSizeOptions: [15,20],
          toolbar: false,
          sorting: false,
          rowStyle: (rowData: PickupOrderAwb) => ({
            background: (props.selectedAwbNumber === rowData.number && props.changed) ? 'orange' : '#fff',
            transition: '0s',
          })
        }}
      />
      </div>
    </div>

  )
}

export default withStyles(styles)(poAwbList);